import { render, staticRenderFns } from "./BlockOverlayReadonly.vue?vue&type=template&id=ebbcc1f4&scoped=true"
import script from "./BlockOverlayReadonly.vue?vue&type=script&lang=js"
export * from "./BlockOverlayReadonly.vue?vue&type=script&lang=js"
import style0 from "./BlockOverlayReadonly.vue?vue&type=style&index=0&id=ebbcc1f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebbcc1f4",
  null
  
)

export default component.exports